import { useDetectActiveUserType } from "hooks/useDetectActiveUserType";
import { canPortfolioTrade, PermissionMode, useCanTradeByIBTags, useCanTradeByJuridicalForm, useIsCBLPortfolio, usePermission } from "./usePermission";

export const useCanTrade = (permissionMode: PermissionMode | undefined = undefined) => {
    const { isAnotherPrivateUser, isAnotherLegalUser } = useDetectActiveUserType();
    const isCBLPortfolio = useIsCBLPortfolio();
    const canTradeIB = useCanTradeByIBTags();
    
    const {
        canTrade: canTradeByJuridicalForm,
        canTradeComplex: canTradeComplexByJuridicalForm
    } = useCanTradeByJuridicalForm();

    const canTrade = usePermission(
        permissionMode,
        canPortfolioTrade
    );

    if (isAnotherPrivateUser) {
        return {
            userCanTrade: false,
            userCanTradeComplex: false,
            userCanSeePortfolio: canTrade && !isCBLPortfolio,
        };
    }

    if (isAnotherLegalUser) {
        return {
            userCanTrade: canTrade && !isCBLPortfolio && canTradeIB && canTradeByJuridicalForm,
            userCanTradeComplex: canTrade && !isCBLPortfolio && canTradeIB && canTradeComplexByJuridicalForm,
            userCanSeePortfolio: true,
        };
    }

    return {
        userCanTrade: canTrade && !isCBLPortfolio && canTradeIB,
        userCanTradeComplex: canTrade && !isCBLPortfolio && canTradeIB,
        userCanSeePortfolio: true,
    };
};
